
import React, { Component } from 'react';
import * as Animated from "animated/lib/targets/react-dom";
import CompanyTile from '../components/companyTile.js';
import TransitionGroup from "react-transition-group/TransitionGroup";
var Customers = require ("../data/companies.json");

export default class CustomerLogos extends Component {
  constructor(props) {
      super(props);
      this.state = {
  			customers: [],
  			animations: []
  		};
  }
  componentDidMount() {
		this._renderProjects(Customers);
	}

	_renderProjects(Customers) {
    setTimeout(function() {
      this.setState(
  			{
  				customers: Customers,
  				animations: Customers.map((_, i) => new Animated.Value(0))
  			},
  			() => {
  				Animated.stagger(
  					100,
  					this.state.animations.map(anim =>
  						Animated.spring(anim, { toValue: 1 })
  					)
  				).start();
  			}
  		);
    }.bind(this), 250);

  }
  render() {
    return (
      <TransitionGroup component="div" className="customers-list row">
        {this.state.customers.map((p, i) => {
          const style = {
            opacity: this.state.animations[i],
            transform: Animated.template`
              translate3d(0,${this.state.animations[i].interpolate({
              inputRange: [0, 1],
              outputRange: ["12px", "0px"]
            })},0)
            `
          };
          return (
            <div className="small-12 medium-4 large-3 tiny-padding">
              <Animated.div style={style}>
                <CompanyTile company={p.company} description={p.description} logo={p.logo} />
              </Animated.div>
            </div>
          );
        })}
      </TransitionGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/customerLogos.js